import { NO_MEALS_CLASS, NO_MEALS_ROUTES } from 'constants/meals';
import { BP, COMFORT, LYRIAWC, PLUS, PREMIER, PREMIUM, SNCFWC, SP, WC_COMP, EVAC } from 'constants/classOfService';
import { customMealCode } from 'types/meals';
import { types } from 'types/passengers';

const allowedPassengerTypes = [types.CHILD, types.ADULT, types.SENIOR, types.YOUTH];

const availableInventoryClasses = ['H', 'A', 'C', 'V', 'W', 'TH', 'TA', 'TW', 'TC', 'TV', 'E', 'EB', 'EH', 'EA', 'X', 'Y', 'Z'];

const availableClassOfServiceCode = [SP, BP, COMFORT, PREMIUM, PLUS, PREMIER, WC_COMP, LYRIAWC, SNCFWC, EVAC];

export const passengerEntitledToMeal = (passenger, seat, classOfService) =>
  somePassengersEntitledToMeal([passenger], [seat], [classOfService]);

export const somePassengersEntitledToMeal = (passengers = [], seats = [], classesOfService = []) => {
  const somePassengersEntitled = passengers
    .filter((passenger) => Boolean(passenger))
    .some(({ type } = {}) => allowedPassengerTypes.includes(type));

  const someSeatsEntitled = seats
    .filter((seat) => Boolean(seat))
    .some(({ inventoryClass } = {}) => availableInventoryClasses.includes(inventoryClass));

  const someClassesOfServiceEntitled = classesOfService
    .filter((classOfService) => Boolean(classOfService?.code))
    .some(({ code } = {}) => availableClassOfServiceCode.includes(code));

  return somePassengersEntitled && (someSeatsEntitled || someClassesOfServiceEntitled);
};

const { NO_MEAL, REGULAR_MEAL } = customMealCode;

export const specialMeal = (meal) => someSpecialMeals([meal]);

export const someSpecialMeals = (meals = []) =>
  meals.some(({ code } = {}) => code !== undefined && code !== null && code !== NO_MEAL && code !== REGULAR_MEAL);

export const isNoMealRoute = (from = '', to = '') => {
  if (!NO_MEALS_ROUTES.has(from)) {
    return false;
  }

  return NO_MEALS_ROUTES.get(from).has(to);
};

export const isNoMealClass = (classOfService = '') => NO_MEALS_CLASS.includes(classOfService);
